import { render, staticRenderFns } from "./RecipeItemIngredientMigrate.vue?vue&type=template&id=1d6de992&"
import script from "./RecipeItemIngredientMigrate.vue?vue&type=script&lang=js&"
export * from "./RecipeItemIngredientMigrate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports